import { useContext } from 'react';
import { SettingsContext, type SettingsContextValue } from '../context/settingsContext';

export const useLayoutSettings = (): SettingsContextValue => useContext(SettingsContext);
